import React from 'react';
import { useTheme } from '@10d/tend-ui-theme';
import cn from 'classnames';
import { RascvetayLogo } from './logos/Rascvetay.js';
import { StroyCenterLogo } from './logos/StroyCenter.js';
import { FskLogo } from './logos/Fsk.js';
import { TochnoLogo } from './logos/Tochno.js';
import { StranaLogo } from './logos/Strana.js';
import { ParitetLogo } from './logos/Paritet.js';
import { TavridaLogo } from './logos/Tavrida.js';
import { InacrticaLogo } from './logos/Inacrtica.js';
import { Root, LogoWrapper } from './styled.js';

const getLogoByName = (tenantName) => {
    switch (tenantName) {
        case 'rascvetay':
            return { logo: React.createElement(RascvetayLogo, null), bgColor: 'white' };
        case 'stroyСenter':
            return { logo: React.createElement(StroyCenterLogo, null), bgColor: 'white' };
        case 'fsk':
            return { logo: React.createElement(FskLogo, null), bgColor: 'black' };
        case 'tochno':
            return { logo: React.createElement(TochnoLogo, null), bgColor: 'white' };
        case 'strana':
            return { logo: React.createElement(StranaLogo, null), bgColor: 'white' };
        case 'paritet':
            return { logo: React.createElement(ParitetLogo, null), bgColor: 'white' };
        case 'tavrida':
            return { logo: React.createElement(TavridaLogo, null), bgColor: 'white' };
        case 'inarctica':
            return { logo: React.createElement(InacrticaLogo, null), bgColor: 'white' };
        default:
            return null;
    }
};
const TenantLogo = ({ logoName, onClick }) => {
    const theme = useTheme();
    const data = getLogoByName(logoName);
    if (!data) {
        return null;
    }
    return (React.createElement(Root, { theme: theme, className: cn(['tend-ui-tenant-logo-root']), "$pointer": !!onClick, onClick: onClick, "$backgroundColor": data.bgColor },
        React.createElement(LogoWrapper, null, data.logo)));
};

export { TenantLogo };
